import { StylesConfig } from '@/components/controls/Button/types'
import { hexToRgb } from '@/helpers/hexToRgb'
import theme from '../theme'

export const ERROR_STYLE_TYPE_COLORS: StylesConfig = {
    primary: {
        original: {
            background: theme.colors.error[500],
            border: theme.colors.error[500],
            color: theme.colors.base.white
        },
        hover: {
            background: theme.colors.error[700],
            border: theme.colors.error[700]
        },
        disabled: {
            background: theme.colors.error[200],
            border: theme.colors.error[200]
        }
    },
    secondary: {
        original: {
            background: theme.colors.base.white,
            border: theme.colors.error[200],
            color: theme.colors.error[500]
        },
        hover: {
            border: theme.colors.error[500]
        },
        disabled: {
            border: theme.colors.error[50],
            color: theme.colors.error[300]
        }
    },
    tertiary: {
        original: { color: theme.colors.error[500] },
        hover: {
            background: hexToRgb(theme.colors.error[500], 0.1),
            border: hexToRgb(theme.colors.error[500], 0.1)
        },
        disabled: { color: theme.colors.gray[300] }
    },
    link: {
        original: { color: theme.colors.error[500] },
        hover: { color: theme.colors.error[700] },
        disabled: { color: theme.colors.gray[300] }
    }
}
